import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"

export default function useManageEnabledUsers() {
	const { showToast } = useToast()

	const onChangeEnabled = useCallback((id, enabled, name) => {
		postSubmit(`${BACKEND_APIS.USER}/access-control`, { uid: id, enabled: enabled })
			.then(() => showToast.success(`Succesfully ${enabled ? "enabled" : "disabled"} ${name}`))
			.catch(() => showToast.success(`Couldn't ${enabled ? "enable" : "disable"} ${name}`))
	}, [])

	return {
		onChangeEnabled,

	}

}